@layer reset, default, hint, error;

@layer reset {
  :host {
    display: block;

    .gcds-date-input__fieldset {
      border: 0;
      padding: 0;
      min-inline-size: auto;

      legend {
        padding: 0;
      }
    }
  }
}

@layer default {
  :host {
    .gcds-date-input__fieldset legend {
      color: var(--gcds-date-input-fieldset-text);
      font: var(--gcds-date-input-fieldset-font-desktop);

      .legend__required {
        margin: var(--gcds-date-input-fieldset-required-margin) !important;
        font: var(--gcds-date-input-fieldset-required-font-desktop);
        vertical-align: middle;
      }

      @media only screen and (width < 48em) {
        font: var(--gcds-date-input-fieldset-font-mobile);

        .legend__required {
          font: var(--gcds-date-input-fieldset-required-font-mobile);
        }
      }
    }

    .gcds-date-input__month,
    .gcds-date-input__year,
    .gcds-date-input__day {
      display: inline-block;
      margin-inline-end: var(--gcds-date-input-margin);

      --gcds-label-font-desktop: var(--gcds-date-input-label-font-desktop);
      --gcds-label-font-mobile: var(--gcds-date-input-label-font-mobile );
    }
  }
}

@layer hint {
  :host {
    gcds-hint {
      margin: var(--gcds-date-input-fieldset-hint-margin);
    }
  }
}

@layer error {
  :host {
    gcds-input.gcds-date-input--error::part(input),
    gcds-select.gcds-date-input--error::part(select) {
      border-color: var(--gcds-date-input-danger-border);
    }
  }
}
